import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import * as Sentry from '@sentry/angular';

Sentry.init({
  dsn: "https://7678ceb3db5cda8de75d213aa1a8a96e@o4504853594832896.ingest.us.sentry.io/4509090393686016",
  sampleRate: 0.6,
  environment: import.meta.env.NG_APP_SENTRY_ENVIRONMENT,
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration()
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
